module.exports = __webpack_public_path__ + "img/img2.ea3460e0.jpg";